import { cn } from '@atlas/ui-primitives'
import { type ReactNode, useLayoutEffect, useRef, useState } from 'react'

/** A collapsible list under a process card: blocked rows, mapped rows, failures. */
export function Details({
	summary,
	isOpen,
	onToggle,
	children,
}: {
	summary: string
	isOpen?: boolean
	onToggle?: (isOpen: boolean) => void
	children: ReactNode
}) {
	const list = useRef<HTMLUListElement>(null)
	// The list scrolls past its height; its bottom edge fades while more is below, so a cut line reads as "scroll".
	const [hasMore, setHasMore] = useState(false)
	const measure = () => {
		const el = list.current
		if (el) setHasMore(el.scrollTop + el.clientHeight < el.scrollHeight - 1)
	}
	// After every render, so new children are measured; an unchanged answer does not render again.
	useLayoutEffect(measure)
	return (
		<details
			open={isOpen}
			onToggle={(e) => {
				onToggle?.(e.currentTarget.open)
				measure()
			}}
			className="flex flex-col gap-ds-2 border-ds-border border-t pt-ds-3"
		>
			<summary className="cursor-pointer text-ds-sm text-ds-text">{summary}</summary>
			<ul
				ref={list}
				onScroll={measure}
				className={cn('mt-ds-2 flex max-h-80 flex-col gap-ds-2 overflow-y-auto', hasMore && 'mask-b-from-80%')}
			>
				{children}
			</ul>
		</details>
	)
}
